import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    margin: '24px 0',
    alignItems: 'center',
    justifyContent: 'center'
  },
  itemWrapper: {
    padding: '12px',
    height: '140px',
    flexShrink: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(50% - 28px)',
    backgroundColor: "".concat(palette.shades[100]),
    border: "1px solid ".concat(palette.shades[300]),
    '& img': {
      width: '100%'
    }
  },
  divider: {
    flexShrink: '0',
    margin: '0 16px'
  }
});
export default useStyles;